import { useEffect, useState } from 'react';

const FONT_WAIT_MS = 4000;

export function useFontsReady() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let live = true;
    const finish = () => {
      if (live) setReady(true);
    };
    const timer = setTimeout(finish, FONT_WAIT_MS);
    const fonts = document.fonts;

    if (fonts?.ready) {
      fonts.ready.then(() => {
        clearTimeout(timer);
        finish();
      });
    } else {
      clearTimeout(timer);
      finish();
    }

    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, []);

  return ready;
}
